module.exports = __webpack_public_path__ + "static/media/close.989b648f.svg";